<!--List of services required from the support worker or provided by the support worker-->
<ion-grid>
  <ion-row
    class="ion-align-items-center"
    *ngFor="let service of services"
  >
    <app-worker-service
      [service]="service"
      (updatedWorkerService)="updateServices($event)"
    ></app-worker-service>
  </ion-row>
</ion-grid>
